/**
 * Returns CSS styles that visually hide an element while keeping it accessible to screen readers.
 * This is commonly known as the "sr-only" (screen reader only) pattern.
 *
 * Use this for content that should be read by assistive technologies but not visible on screen,
 * such as semantic headings that provide structure without affecting visual design.
 *
 * @returns {Object} CSS-in-JS style object for visually hidden, screen-reader-accessible content
 *
 * @example
 * import {screenReaderOnly} from '../utils/screenReaderOnly';
 *
 * <h1 style={screenReaderOnly()}>Page Title</h1>
 */
export const screenReaderOnly = () => ({
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
});
